import doNothing from '#helpers/api/doNothing.js'
import Logger from '#helpers/logging/Logger.js'
import { config, pushModal } from 'jenesius-vue-modal'

config({ scrollLock: true, animation: 'modal-list', backgroundClose: true, escClose: false })

/**
 * @param {string | import('vue').Component} [component] - The component to mount
 * @param {object} [props] - The props to give to the component
 * @param {object} [options] - Options for the modal
 * @param {boolean} [options.backgroundClose] - Can the modal be closed by clicking outside the modal?
 * @param {boolean} [options.escClose] - Can the modal be closed by pressing escape?
 * @returns {Promise} - An async modal
 */
export async function showModal(
	component = null,
	props = {},
	{ backgroundClose = false, escClose = false } = {},
) {
	// const close = () => popModal()
	const modal = await pushModal(component, { onClose: () => modal.close(), ...props }).catch(
		doNothing,
	)

	Logger.debug(`Open modal ${modal.id}`)
	/* oxlint-disable-next-line */
	modal.onclose = event => {
		let canClose = true
		if (event.esc) {
			canClose = escClose
		}
		if (event.background) {
			canClose = backgroundClose
		}
		Logger.debug(`trying to close modal ${modal.id}`, { canClose })
		return canClose
	}
	return modal
}

export default showModal
